import { defineStore } from 'pinia'
import { userService } from '@/_services'

export const useUsersStore = defineStore('users', {
  state: () => ({ 
    ready: false,
    users: [],
    roles: [],
    merchs: [],
    coords: [],
    customers: [],
    selectedUserProfile: null,
    hasNotViewedUpdate: false
  }),
  
  actions: {
    async loadAllUserAndProfile() {
      
      this.users = await userService.listCheckProfiles()
      this.roles = await userService.getAllRoles()

      this.users.map( item => {
        let hash = null
        if(item.city){
          hash = Object.values(item).join('$') + item.type.name + '$' + item.city.name + '$'
        } else {
          hash = Object.values(item).join('$') + item.type.name + '$'
        }
        item.hash = hash
      })
      this.ready = true
    },

    async loadAllMerchs() {
      this.merchs = await userService.merchs()
    },

    async loadAllCoords() {
      this.coords = await userService.coordinators()
    },

    async loadAllCustomers() {
      this.customers = await userService.customers()
    },

    addUser(user) {
      return userService.addUser(user).then(data => {
        let hash = null
        if(data.city){
          hash = Object.values(data).join('$') + data.type.name + '$' + data.city.name + '$'
        } else {
          hash = Object.values(data).join('$') + data.type.name + '$'
        }
        data.hash = hash
        this.users.push(data)
      }).catch((error) => {
        window.alert(error.response.data.message)
      })
    },

    deleteUser(id) {
      return userService.removeUser(id).then(() => {
        let index = this.users.findIndex((item) => item.id === id)
        if (index !== -1) {
          this.users.splice(index, 1)
        }
      })
    },

    loadUserProfile(id) {
      return userService.profile(id).then(data => {
        this.selectedUserProfile = data
      })
    },

    checkUpdatedProfile(userId) {
      return userService.checkUpdated(userId).then(() => {
        this.users.find(el => el.id == userId).hasChanged = false
        if(!this.users.filter(el => el.hasChanged == true).length) this.hasNotViewedUpdate = false
      })
    },

    updateUserProfile(userId) {
      this.hasNotViewedUpdate = true
      if(!this.users.length) return
      this.users.find(el => el.id == userId).hasChanged = true
    },

    checkUpdatedUserProfile(userId) {
      if(!this.users.length) return
      this.users.find(el => el.id == userId).hasChanged = false
      if(!this.users.filter(el => el.hasChanged == true).length) this.hasNotViewedUpdate = false
    },

    hasNotViewedUpdatedProfile() {
      return userService.hasNotViewedUpdatedProfile().then((data) => {
        this.hasNotViewedUpdate = data
      })
    }
  },
  
})